import { Editor, type NodeEntry, Range, Text } from 'slate';

export default function textInRange(editor: Editor, range: Range): string {
  const nodes: NodeEntry<Text>[] = Array.from(
    Editor.nodes(editor, { at: range, match: Text.isText })
  );

  let text = '';
  for (const [node, path] of nodes) {
    const intersection = Range.intersection(range, {
      anchor: { path, offset: 0 },
      focus: { path, offset: node.text.length },
    });

    if (!intersection) continue;

    text += node.text.substring(
      intersection.anchor.offset,
      intersection.focus.offset
    );
  }
  return text;
}
